import store from '@/store'

export const reader = {
  mounted(el, val) {
    if (val.value) return
    store.commit('notification/setNotificationOneItemDom', el)
  },
}
